import { Page, PageHeader } from "@/components/Bits";
import { SecurityTab } from "@/pages/Settings";
import { useAuth } from "@/context/AuthContext";

export default function MyAccount() {
  const { user } = useAuth();
  return (
    <Page>
      <PageHeader overline="Your account" title="My Account"
        subtitle="Your sign-in and security preferences." />
      <div className="card-surface p-5 max-w-2xl mb-6" data-testid="account-identity">
        <div className="grid sm:grid-cols-2 gap-4">
          <div>
            <div className="overline text-navy/65 mb-1">Name</div>
            <div className="text-navy font-medium" data-testid="account-name">{user?.name || "—"}</div>
          </div>
          <div>
            <div className="overline text-navy/65 mb-1">Email</div>
            <div className="text-navy font-medium" data-testid="account-email">{user?.email}</div>
          </div>
          <div>
            <div className="overline text-navy/65 mb-1">Role</div>
            <div className="text-navy font-medium capitalize" data-testid="account-role">{user?.role}</div>
          </div>
        </div>
      </div>
      <SecurityTab />
    </Page>
  );
}
